export default class LogoutTaskKind {
  static REGULAR = 'REGULAR';
  static GLOBAL = 'GLOBAL';
  static SINGLE_SESSION_PER_USER = 'SINGLE_SESSION_PER_USER';
}
